import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import DesignStudioPage from '../Design/DesignStudioPage';

const BrandDropPage = () => {
  const { brandId } = useParams();
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexShrink: 0 }}>
        <Typography variant="h4" fontWeight={700}>
          Drop Planning
        </Typography>
        <Button variant="outlined" onClick={() => navigate(`/brands/${brandId}`)}>
          Back to Planning Dashboard
        </Button>
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          minHeight: 0,
          overflow: 'hidden',
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <DesignStudioPage mode="dropOnly" />
      </Box>
    </Box>
  );
};

export default BrandDropPage;
